import { motion } from 'motion/react';

interface DoctorCardProps {
  doctor: {
    name: string;
    title: string;
    image: string | null;
    bio: string;
    gender?: 'male' | 'female';
  };
  index: number;
}

function DoctorCard({ doctor, index }: DoctorCardProps) {
  // Split name into Arabic and English parts
  const nameParts = doctor.name.split(' - ');
  const arabicName = nameParts[1] || nameParts[0];
  const englishName = nameParts[0];

  // Split bio into Arabic and English parts
  const bioParts = doctor.bio.split(' - ');
  const arabicBio = bioParts.length > 1 ? bioParts[1] : null;
  const englishBio =
    bioParts.length > 1
      ? bioParts[0].replace(/^Consultant,?\s*/i, '')
      : bioParts[0];

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.05, duration: 0.5 }}
      whileHover={{ y: -8, transition: { duration: 0.2 } }}
      className="flex flex-col items-center gap-4 rounded-xl border border-[#E5E5E5] bg-white p-6 shadow-[0px_0px_20px_0px_rgba(0,0,0,0.05)] transition-all hover:shadow-[0px_4px_20px_0px_rgba(0,0,0,0.1)]"
    >
      {/* Top section with avatar and names */}
      <div className="flex w-full items-center justify-center gap-4">
        {/* Avatar */}
        <div className="h-20 w-20 flex-shrink-0 overflow-hidden rounded-full border-4 border-white bg-white shadow-sm">
          <img
            src={
              doctor.image
                ? doctor.image
                : doctor.gender === 'male'
                  ? '/images/icons/male.svg'
                  : '/images/icons/female.svg'
            }
            alt={doctor.name}
            className="h-full w-full object-cover"
            loading="lazy"
          />
        </div>
        {/* Names */}
        <div className="flex flex-1 flex-col gap-1 text-right">
          <h3 className="text-lg leading-tight font-bold text-black">
            {arabicName}
          </h3>
          <p className="text-lg leading-tight font-bold text-black">
            {englishName}
          </p>
        </div>
      </div>

      {/* Divider */}
      <div className="h-px w-full bg-[#E5E5E5]"></div>

      {/* Bio section */}
      <div className="flex w-full flex-col gap-1 text-right">
        <p className="text-base leading-tight text-[#494949]">{arabicBio}</p>
        <p className="text-base leading-tight text-[#494949]">{englishBio}</p>
      </div>
    </motion.div>
  );
}

export default DoctorCard;
